import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/about", label: "品牌介绍" },
  { to: "/news", label: "产品资讯" },
  { to: "/contact", label: "联系我们" },
];

const productLinks = [
  { to: "/product/berry-gummy", label: "糖心莓莓夹心软糖" },
  { to: "/product/butter-cookie", label: "手工黄油曲奇礼盒" },
  { to: "/product/salted-caramel-nougat", label: "海盐焦糖牛轧糖" },
  { to: "/product/peach-soda", label: "白桃气泡饮" },
];

const socials = [
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-zhihu-fill", label: "知乎" },
  { icon: "ri-tiktok-fill", label: "抖音" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="w-full px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <BrandLogo light />
            <p className="mt-5 text-sm leading-relaxed text-foreground-400">
              糖心VLGO，始于对真实的坚持。我们相信，每一份甜都应该来得自然、吃得安心，也值得被认真对待。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socials.map((s) => (
                <span
                  key={s.label}
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-foreground-100 cursor-pointer transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg leading-none`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">快速导航</h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">热门产品</h4>
            <ul className="flex flex-col gap-3">
              {productLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-5">联系方式</h4>
            <ul className="flex flex-col gap-3 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5 leading-none"></i>
                <span>上海市静安区甜山路 88 号糖心创意园 6 楼</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400 leading-none"></i>
                <span>400-820-8899</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400 leading-none"></i>
                <span>hello@tangxin-vlgo.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 糖心VLGO 品牌官方 · 保留所有权利 · 本站内容均为演示示例
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">使用条款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}